import React from 'react';
import { WithTestIdOptional } from 'shared-client/types/test';
import useDelayedDisplay from './hooks/useDelayedDisplay';

interface SpinnerProps extends WithTestIdOptional {
	waitMs: number;
}

/**
 * Spinner SVG for loading purposes
 *
 * @returns
 */
function CenterSpinner(props: SpinnerProps) {
	const display = useDelayedDisplay(props.waitMs);
	const testId = `spinner-${props.testId ? props.testId : 'center'}`;

	if (!display) {
		return null;
	}

	return (
		<div className="center-spinner">
			<div className="center-spinner__box">
				<div className="center-spinner__spinner" data-testid={testId}>
					<div className="center-spinner__cube1" />
					<div className="center-spinner__cube2" />
				</div>
			</div>
		</div>
	);
}

CenterSpinner.defaultProps = {
	waitMs: 200,
};

export default React.memo(CenterSpinner);
